<template>
	<div id="certificate-management-container">
		<b-tabs v-model="currentActiveTab" 
			nav-class="main-tabs nav nav-tabs" 
			nav-wrapper-class="main-tabs-row"
			content-class="certificate-management-content-wrapper">

			<b-tab :active="currentActiveTab === 0">
				<template v-slot:title>
					<div class="tab-title-wrapper">
						<span class="tab-title">Certificates</span>
					</div>
				</template>

				<TemplateCertificates v-if="currentActiveTab === 0" />
			</b-tab>

			<b-tab :active="currentActiveTab === 1">
				<template v-slot:title>
					<div class="tab-title-wrapper">
						<span class="tab-title">Issued Certificates</span>
					</div>
				</template>
				<IssuedCertificates v-if="currentActiveTab === 1"/>
			</b-tab>


		</b-tabs>

	</div>
</template>

<script>
import TemplateCertificates from "../../components/Admin/Certificate/TemplateCertificates.vue";
import IssuedCertificates from "../../components/Admin/Certificate/IssuedCertificates.vue";

export default {
	name: "CertificateManagement",
	data() {
		return {
			loading: false,
			currentActiveTab: 0,
		};
	},
	methods: {},
	components: { TemplateCertificates, IssuedCertificates },
	props: { productVariantData: Object },
	computed: {

	},
	created() {

	},
	watch: {

	},
};
</script>

<style scoped>
#certificate-management-container {
	background-color: #f5f5f5;
	height: calc(100svh - var(--header-height));
	padding: 0;
}

#certificate-management-container .certificate-management-content-wrapper {
	max-height: calc(100svh - var(--header-height));
	overflow-y: auto;
	padding: 0px;
}

#certificate-management-container .main-tabs-row {
	height: auto;
	padding: 0px;
	height: 65px;
}

#certificate-management-container .main-tabs a,
#certificate-management-container .main-tabs .nav-link {
	height: 65px;
	padding: 0px 20px;
	line-height: normal;
}

#certificate-management-container .nav {
	display: block;
	overflow-x: auto;
	white-space: nowrap;
	padding: 0px 40px;
}

#certificate-management-container .nav-item {
	display: inline-block;
	float: none !important;
	height: 65px;
	margin: 0;
}
</style>

<style scoped>

.tab-title-wrapper {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;
	box-sizing: border-box;
}

.tab-title {
	color: #000;
	font-family: "Circular Std";
	font-size: 12px;
	font-style: normal;
	font-weight: 450;
	line-height: normal;
	letter-spacing: -0.36px;
}

.loading-overlay {
	margin-top: 38dvh;
	margin-bottom: 38dvh;
}

.empty-list {
	display: flex;
	justify-content: space-around;
	font-size: 15px;
	margin-top: 25dvh;
	margin-bottom: 35dvh;
	font-weight: 700;
}
</style>